import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms'
import { TooltipModule } from 'ng2-tooltip-directive';

import { AsistenteDireccionFormComponent } from './asistente-direccion-form/asistente-direccion-form.component';
import { ContactoFormComponent } from './contacto-form/contacto-form.component';
import { DireccionFormComponent } from './direccion-form/direccion-form.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { PaginaNoEncontradaComponent } from '../../pagina-no-encontrada/pagina-no-encontrada.component';
import { TooltipComponent } from './tooltip/tooltip.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TooltipModule
  ],
  declarations: [
    AsistenteDireccionFormComponent, 
    ContactoFormComponent, 
    DireccionFormComponent, 
    FooterComponent, 
    HeaderComponent, 
    PaginaNoEncontradaComponent, 
    TooltipComponent
  ],
  entryComponents: [
    DireccionFormComponent,
    ContactoFormComponent,
    AsistenteDireccionFormComponent
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    PaginaNoEncontradaComponent,
    DireccionFormComponent,
    ContactoFormComponent,
    AsistenteDireccionFormComponent,
    FormsModule,
    TooltipComponent
  ]
})
export class SharedModule { }
